import { Controller, useFormContext } from 'react-hook-form';

import { PhoneInput } from '../phone-input';

import type { PhoneInputProps } from '../phone-input';

// ----------------------------------------------------------------------

export type RHFPhoneInputProps = Omit<PhoneInputProps, 'value' | 'onChange'> & {
  name: string;
  endAdornment?: any;
};

export function RHFPhoneInput({ name, helperText, endAdornment, ...other }: RHFPhoneInputProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <PhoneInput
          {...field}
          fullWidth
          error={!!error}
          helperText={error?.message ?? helperText}
          endAdornment={endAdornment}
          onChange={(value) => {
            if (!value) {
              field.onChange('');
              return;
            }
            field.onChange(value);
          }}
          {...other}
        />
      )}
    />
  );
}
